import React from "react";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import { useEffect, useRef } from "react";
import { gsap, ScrollTrigger } from "../../utils/gsapSetup";

const Main = () => {
    const { t, i18n } = useTranslation();
    const titleRef = useRef(null);
    const subtitleRef = useRef(null);

    useEffect(() => {
        if (!titleRef.current || !subtitleRef.current) return;
        const mm = gsap.matchMedia();

        // Desktop/tablet default animasyonlar
        gsap.fromTo(
            titleRef.current,
            { opacity: 0, y: 40 },
            { opacity: 1, y: 0, duration: 1, ease: "power3.out" }
        );
        gsap.fromTo(
            subtitleRef.current,
            { opacity: 0, y: 20 },
            { opacity: 1, y: 0, delay: 0.6, duration: 0.8, ease: "power2.out" }
        );

        // Mobil: daha abartılı efektler
        mm.add("(max-width: 767px)", () => {
            // Başlık bob/elastic efekti
            gsap.fromTo(
                titleRef.current,
                { scale: 0.85, rotate: 0.0001 },
                { scale: 1, duration: 0.9, ease: "elastic.out(1, 0.5)", delay: 0.15 }
            );
            // Subtitle shimmer benzeri hafif sarkaç
            gsap.fromTo(
                subtitleRef.current,
                { y: 10, opacity: 0 },
                { y: 0, opacity: 1, duration: 0.8, ease: "back.out(1.4)", delay: 0.4 }
            );

            // Video parallax-scale efekti (scroll ile hafif büyüme)
            const videoEl = document.getElementById("hero-video");
            if (videoEl) {
                gsap.fromTo(
                    videoEl,
                    { scale: 1 },
                    {
                        scale: 1.12,
                        ease: "none",
                        scrollTrigger: {
                            trigger: "#hero-video-wrapper",
                            start: "top top",
                            end: "bottom top",
                            scrub: true,
                        },
                    }
                );
            }
        });

        return () => mm.revert();
    }, []);

    return (
        <motion.section className="relative video-main select-none">
            <div className="absolute overflow-hidden w-full h-full main flex items-center text-center justify-center flex-col text-[#fafafa] bg-black">
                <div className="absolute w-full h-full bg-black z-20 opacity-40 top-0 left-0 pointer-events-none"></div>
                <div className="relative z-20">
                    <h1 ref={titleRef} className="mb-10 text-[14vw] md:text-[8vw] lg:text-[5vw] leading-none tracking-widest font-bold">
                        {t("hero.name")}
                    </h1>
                    {/* <hr className="line w-40 bg-white h-0.5 m-auto mb-8"></hr> */}

                    <div className="flex justify-center items-center mb-10">
                        <div className="loader2"></div>
                    </div>

                    <h2 ref={subtitleRef} className="text-2xl font-bold uppercase">
                        {t("hero.subtitle")}
                    </h2>
                </div>
            </div>

            <div className="!w-[100%] h-full relative z-10 overflow-hidden" id="hero-video-wrapper">
                <video
                    className="w-full h-full video"
                    loop
                    muted
                    autoPlay
                    playsInline
                    preload="metadata"
                    poster="/videos/waves-poster.jpg"
                    id="hero-video"
                    aria-hidden="true"
                    tabIndex={-1}
                >
                    <source src="/videos/waves-mobile.mp4" type="video/mp4" media="(max-width: 767px)" />
                    <source src="/videos/waves.mp4" type="video/mp4" />
                </video>
            </div>
        </motion.section>
    );
};

export default Main;
